import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

export const BookingSuccess = ({ confirmed }) => {
  const fmt = new Intl.DateTimeFormat("fr-FR", {
    weekday: "long", day: "numeric", month: "long", year: "numeric",
    hour: "2-digit", minute: "2-digit", timeZone: "Europe/Paris",
  }).format(new Date(confirmed.slot_start));

  return (
    <div className="mx-auto max-w-3xl px-6 py-24 text-center" data-testid="booking-success">
      <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.6 }}>
        <CheckCircle2 size={56} strokeWidth={1.5} className="mx-auto text-argia-red" />
        <h1 className="mt-6 font-display text-4xl font-bold tracking-tight text-argia-ink sm:text-5xl">
          Rendez-vous confirmé !
        </h1>
        <p className="mt-5 text-base leading-relaxed text-argia-muted md:text-lg">
          Merci {confirmed.name.split(" ")[0]} — votre rendez-vous du{" "}
          <span className="font-semibold text-argia-ink">{fmt}</span>{" "}
          est bien enregistré dans l'agenda d'Aurélie. Vous serez recontacté(e) si besoin.
        </p>
        <div className="mx-auto mt-10 max-w-md rounded-2xl bg-argia-stone p-8 text-left">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-argia-muted">Récapitulatif</p>
          <p className="mt-4 text-sm text-argia-ink"><span className="font-semibold">Profil :</span> {confirmed.client_type === "professionnel" ? "Professionnel" : "Particulier"}</p>
          <p className="mt-2 text-sm text-argia-ink"><span className="font-semibold">Besoins :</span> {confirmed.needs.join(", ")}</p>
          {confirmed.offer && <p className="mt-2 text-sm text-argia-ink" data-testid="booking-success-offer"><span className="font-semibold">Offre envisagée :</span> {confirmed.offer}</p>}
          <p className="mt-2 text-sm text-argia-ink"><span className="font-semibold">Créneau :</span> {fmt}</p>
        </div>
      </motion.div>
    </div>
  );
};
